import { useEffect, useRef } from "react";
//USE CALLBACK TYPE
type SocketEventCallback<T> = (data: T) => void;

function useSocket<EventType>({
  callback,
  url,
}: {
  url: string;
  callback: SocketEventCallback<EventType>;
}) {
  const connection = useRef<WebSocket | null>(null);

  useEffect(() => {
    const socket = new WebSocket(url);

    // Connection opened
    socket.addEventListener("open", () => {
      socket.send("Connection established");
    });

    // Listen for messages
    socket.addEventListener("message", (event) => {
      callback(JSON.parse(event.data));
    });

    connection.current = socket;

    return () => connection.current?.close();
  }, [url, callback]);
}

export { useSocket };
